<template>
  <div class="absolute bottom-0 right-0 text-septenary font-bold m-2 lg:m-4 flex flex-col items-end gap-2">
    <slot />
    <RouterLink :to="to" class="flex gap-2 items-center">
      <span class="underline text-hyperlink hover:text-primary">{{ label || $t("View all tickets") }}</span>
      <ArrowRightCircleIcon class="w-6 h-6 text-link-color" />
    </RouterLink>
  </div>
</template>
<script setup>
import { RouterLink } from "vue-router";
import { ArrowRightCircleIcon } from "@heroicons/vue/20/solid";

defineProps({
  to: { required: true },
  label: { default: null },
});
</script>
